import api from "./api";
import { createQueryParams } from "../Helpers/QueryParams";

export const getBillChart = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/bills/graph-data?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Chart Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getBills = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/bills?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Bills");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getBillById = async (billId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/bills/${billId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Bill");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
} 

export const addBills = async (data: FormData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/bills/v2`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
                'Content-Type': 'multipart/form-data', // Important for file uploads
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Bill");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const updateBill = async (billId: string, data: FormData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage
        data.append('_method', 'PUT');

        const response = await api.post(`/bills/${billId}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
                'Content-Type': 'multipart/form-data', // Important for file uploads
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to update Bill");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const reviewBill = async (billId: string, data: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.put(`/bills/${billId}/review`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
                // 'Content-Type': 'multipart/form-data', // Important for file uploads
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to update Bill");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getBillsData = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/bills/data?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Chart Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}